import { WordProvider } from "./WordProvider";
import { TypingTestState } from "./types";

export class TypingTest {
    private words: string[];
    private currentWordIndex = 0;
    private _state = TypingTestState.NotStarted;
    private hasInputError = false;
    private wordProvider: WordProvider
    private _currentInput = "";
    private _errorPositions: number[] = [];
    private testSize: number;
    private _startTime: number | null = null
    private _endTime: number | null = null
    private _characterCount: number = 0;
    private _totalCharacterCount: number = 0;
    private _wpm: number = 0;
    private _accuracy: number = 0;

    constructor(wordProvider: WordProvider, numberOfWords: number) {
        this.wordProvider = wordProvider
        this.testSize = numberOfWords;
        this.reset();
    }

    public get errorPositions(): number[] {
        return this._errorPositions;
    }

    public get currentInput(): string {
        return this._currentInput;
    }

    public get state(): TypingTestState {
        return this._state;
    }

    getWords() {
        return this.words;
    }

    getCurrentWordIndex() {
        return this.currentWordIndex;
    }

    consumeWord() {
        if (this.words[this.currentWordIndex] !== this._currentInput) {
            this._errorPositions.push(this.currentWordIndex);
        } else {

            this._characterCount += this._currentInput.length + 1; // input + space
        }
        this._totalCharacterCount += this.words[this.currentWordIndex].length + 1; // word + space
        this.currentWordIndex++;
        if (this.currentWordIndex === this.words.length) {
            this._endTime = Date.now();
            this._state = TypingTestState.Completed;
            this.calculateWPM();
        }
        this._currentInput = "";
        this.hasInputError = false;

    }

    checkWord(matchString: string) {
        this._currentInput = matchString;
        this.hasInputError = false;
        if (this._state === TypingTestState.NotStarted) {
            this._startTime = Date.now()
            this._state = TypingTestState.InProgress;
        }
        const currentWord = this.words[this.currentWordIndex];
        if (matchString === "") {
            this.hasInputError = false;
            return;
        }
        if (matchString.length > currentWord.length) {
            this.hasInputError = true;
            return;
        }
        if (!currentWord.startsWith(matchString)) {
            this.hasInputError = true;
            return;
        }
        if (this.currentWordIndex === this.words.length - 1) {
            if (currentWord === matchString) {
                this.hasInputError = false
                this.consumeWord()
            }
        }
        this.hasInputError = false
    }

    calculateWPM() {
        if (this.state == TypingTestState.Completed) {
            const end = this._endTime || 0;
            const start = this._startTime ||0;
            const durationMillis = end - start;
            const wordCount = this._characterCount / 5;
            const durationMinutes = durationMillis / (1_100 * 60);
            this._wpm = wordCount/durationMinutes;
            this._accuracy = (this._characterCount / this._totalCharacterCount) * 100;
        }
    }

    inputError() {
        return this.hasInputError;
    }

    reset() {
        this.currentWordIndex = 0;
        this._state = TypingTestState.NotStarted;
        this.hasInputError = false;
        this.words = this.wordProvider.getWords(this.testSize);
        this._currentInput = "";
        this._errorPositions = [];
        this._startTime = null;
        this._endTime = null;
        this._characterCount = 0;
        this._totalCharacterCount = 0;
        // this._accuracy = 0;
    }

    get wpm() {
        return this._wpm;
    }

    get accuracy() {
        return this._accuracy;
    }

    getDebugInfo() {
        return `
            Current Word Index: ${this.getCurrentWordIndex()}
            Test State: ${this.state}
            Input Error: ${this.inputError()}
            Current Word: ${this.getWords()[this.getCurrentWordIndex()]}
            Current Input: ${this.currentInput}
            Error Positions: ${this.errorPositions}
        stats:
            Start Time: ${this._startTime}
            End Time: ${this._endTime}
            Duration: ${(this._startTime || 0) - (this._endTime || 0)}
            Character count: ${this._characterCount}
            Total Character Count: ${this._totalCharacterCount}
            WPM: ${this._wpm}
            Accuracy: ${this._accuracy}%

            `
    }

    get completed() {
        return this.state === TypingTestState.Completed;
    }
    get inProgress() {
        return this.state === TypingTestState.InProgress;
    }
    get notStarted() {
        return this.state === TypingTestState.NotStarted;
    }
}